import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { FaLock, FaSpinner, FaEye, FaEyeSlash, FaCheckCircle, FaArrowLeft } from "react-icons/fa";
import "../styles/AuthForm.css";
import "../styles/RecoverPassword.css";
export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [tokenValid, setTokenValid] = useState(null);
  const [tokenEmail, setTokenEmail] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setTokenValid(false);
      setError("Token no proporcionado");
      return;
    }

    const verifyToken = async () => {
      try {
        const response = await axios.get(
          `https://reanimeitor.com/backend/reset_password.php?token=${token}`
        );
        if (response.data.valid) {
          setTokenValid(true);
          setTokenEmail(response.data.email || "");
        } else {
          setTokenValid(false);
          setError(response.data.error || "Token inválido o expirado");
        }
      } catch (err) {
        setTokenValid(false);
        setError("Error al verificar el token");
      }
    };

    verifyToken();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!newPassword || newPassword.length < 8) {
      setError("La contraseña debe tener al menos 8 caracteres");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Las contraseñas no coinciden");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        "https://reanimeitor.com/backend/reset_password.php",
        {
          token: token,
          new_password: newPassword
        },
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        setError(response.data.error || "Error al restablecer contraseña");
      }
    } catch (err) {
      setError("Error de conexión");
    } finally {
      setLoading(false);
    }
  };

  if (tokenValid === null) {
    return (
      <div className="auth-form-container">
        <div className="auth-form-header">
          <h2>Verificando enlace...</h2>
          <div className="loading-spinner">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-form-container">
      <div className="auth-form-header">
        <div className="auth-form-logo">
          <span className="auth-form-logo-icon">⚡</span>
          <span className="auth-form-logo-text">Reanimeitor</span>
        </div>
        <h2 className="auth-form-title">Restablecer Contraseña</h2>
        <p className="auth-form-subtitle">Crea una nueva contraseña para tu cuenta</p>
      </div>

      {!tokenValid ? (
        <div className="auth-error-state" style={{ textAlign: 'center', padding: '20px' }}>
          <div className="error-icon" style={{ fontSize: '3rem', marginBottom: '16px' }}>⚠️</div>
          <h3 style={{ color: '#ef4444', marginBottom: '8px' }}>Enlace inválido</h3>
          <p style={{ color: '#94a3b8', marginBottom: '20px' }}>{error || "El enlace ha expirado o no es válido"}</p>
          <Link to="/login" className="auth-submit-btn" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}>
            <FaArrowLeft /> Volver al inicio de sesión
          </Link>
        </div>
      ) : success ? (
        <div className="verification-success">
          <div className="success-animation">
            <FaCheckCircle className="success-icon" />
          </div>
          <h3>¡Contraseña actualizada!</h3>
          <p>Serás redirigido al inicio de sesión...</p>
        </div>
      ) : (
        <>
          {error && <div className="form-error-message">{error}</div>}
          
          {tokenEmail && (
            <p style={{ color: '#94a3b8', textAlign: 'center', marginBottom: '16px', fontSize: '0.9rem' }}>
              Para: <strong style={{ color: '#ffcc00' }}>{tokenEmail}</strong>
            </p>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <div className="input-with-icon">
                <FaLock className="input-icon" />
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-input"
                  placeholder="Nueva contraseña (mín. 8 caracteres)"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  disabled={loading}
                />
                <button
                  type="button"
                  className="password-toggle-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)' }}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <div className="form-group">
              <div className="input-with-icon">
                <FaLock className="input-icon" />
                <input
                  type="password"
                  className="form-input"
                  placeholder="Confirmar contraseña"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  disabled={loading}
                />
              </div>
            </div>

            <button
              type="submit"
              className="auth-submit-btn"
              disabled={loading || !newPassword || !confirmPassword}
            >
              {loading ? (
                <div className="loading-spinner">
                  <div className="spinner"></div>
                  Actualizando...
                </div>
              ) : "Restablecer contraseña"}
            </button>
          </form>
        </>
      )}
    </div>
  );
}